import { Injectable, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LocalStorageService } from '@app/shared/services/local-storage/local-storage.service';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationStateService implements OnInit {
  organization_id: any;
  // Initialize with a default value (e.g., 'DEFAULT' or 'ADMIN')
  private navSource = new BehaviorSubject<string>('1');
  dataInfo: any;

  // Expose as observable for components to subscribe
  currentNavType = this.navSource.asObservable();
  // Track current URL
  private currentUrlSource = new BehaviorSubject<string>('');
  currentUrl = this.currentUrlSource.asObservable();

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router
  ) {
    this.dataInfo = this.localStorageService.getLocalStorageItem('response')
    console.log("dataINfo:", this.dataInfo)
    console.log("  currentUrl obs", this.currentUrl)
    // Track URL changes
    // this.trackUrlChanges();
    this.updateNavBar()
  }
  ngOnInit(): void {
    throw new Error('Method not implemented.');
    console.log("  currentNavType = this.navSource.asObservable();", this.currentNavType)
  }

  private updateNavBar() {
    this.organization_id = this.dataInfo.data.organization_id
    if (this.dataInfo.data.type_id === 1) {
      const organizationInfo = this.localStorageService.getLocalStorageItem("organizationInfo");
      this.organization_id = organizationInfo.organization_id
    }
    // const type_id = this.dataInfo.data.type_id
    const type_id = this.localStorageService.getLocalStorageItem('type_id')
    console.log("my type id:", type_id)
    if (type_id === "1" || type_id === 1) {
      this.updateNav(type_id);
    } else if (type_id === "2" || type_id === 2) {
      this.updateNav(type_id);
    } else if (type_id === "3" || type_id === 3) {
      this.updateNav(type_id);
    } else {
      this.updateNav('DEFAULT');
    }
  }

  // Track URL changes and update navigation type accordingly
  // private trackUrlChanges() {
  //   this.router.events.pipe(
  //     filter(event => event instanceof NavigationEnd)
  //   ).subscribe((event: NavigationEnd) => {
  //     console.log('Current URL:', event.urlAfterRedirects);
  //     this.currentUrlSource.next(event.urlAfterRedirects);
  //     const dashboards = ['/dashboard2'];
  //     if (dashboards.includes(this.router.url)) {
  //       this.updateNavBar();
  //     }
  //     // Update navigation type based on URL
  //     //this.updateNavBasedOnUrl(event.urlAfterRedirects);
  //   });
  // }
  // // Update navigation type based on current URL
  // private updateNavBasedOnUrl(url: string) {
  //   console.log("url::", url)
  //   if (url.includes('/admin')) {
  //     this.updateNav('ADMIN');
  //   } else if (url.includes('/user')) {
  //     this.updateNav('USER');
  //   } else if (url.includes('/dashboard')) {
  //     this.updateNav('DASHBOARD');
  //   } else if (url.includes('/organization')) {
  //     this.updateNav('ORGANIZATION');
  //   } else {
  //     this.updateNav('DEFAULT');
  //   }
  // }

  // Method to trigger the update
  updateNav(type: string) {
    console.log("updateNave type:", type)
    this.navSource.next(type);
  }

  setOrganization_id(organization_id) {
    console.log("setOrganization_id :", organization_id)
    this.organization_id = organization_id
    this.updateOrganizationInLocalStorage(this.organization_id)

  }
  getOrganization_id() {
    this.organization_id;
  }
  updateOrganizationInLocalStorage(orgId: number) {
    // 1. Retrieve the full object (it parses JSON automatically usually)
    let storedResponse = this.localStorageService.getLocalStorageItem("response");
    console.log("storedResponse :", storedResponse)
    // 2. Update the organization_id
    // We check if 'data' exists because your previous code accessed 'userInfo.data.type_id'
    if (storedResponse && storedResponse.data) {
      storedResponse.data.organization_id = orgId;
    } else if (storedResponse) {
      // Fallback: if the structure is flat (no 'data' wrapper)
      storedResponse.organization_id = orgId;
    }
  }
}